let lastGlobalSaveHadChanges = false;

export const setGlobalSaveHadChanges = (value: boolean) => {
  lastGlobalSaveHadChanges = value;
};

export const consumeGlobalSaveHadChanges = (): boolean => {
  const value = lastGlobalSaveHadChanges;
  lastGlobalSaveHadChanges = false;
  return value;
};
